import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  return (
    <div data-testid="payment-cancel" className="max-w-2xl mx-auto px-6 py-24 text-center">
      <XCircle size={48} className="text-[#C2B29F] mx-auto"/>
      <div className="eyebrow mt-6">Payment Cancelled</div>
      <h1 className="font-serif-luxe text-4xl text-[#FAF8F5] mt-3">Your bag is still saved.</h1>
      <p className="text-[#C2B29F] mt-4">No card was charged. You can resume checkout anytime.</p>
      <div className="mt-8 flex flex-wrap gap-3 justify-center">
        <Link to="/checkout" className="btn-gold">Try Again</Link>
        <Link to="/shop" className="btn-outline-gold">Continue Shopping</Link>
      </div>
      {orderId && <div className="mt-6 text-[10px] tracking-[0.24em] uppercase text-[#C2B29F]">Order #{orderId.slice(0,8).toUpperCase()}</div>}
    </div>
  );
}
